import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';

export interface ProgressaoRegisto {
  id: string;
  funcionarioId: string;
  dataProgressao: string;
  nivelAnterior: number;
  nivelNovo: number;
  pontosDescontados: number;
  observacoes: string | null;
  aceleradorRemuneratorio: boolean;
  createdAt: string;
}

export function useProgressoes(funcionarioId: string | null) {
  const [progressoes, setProgressoes] = useState<ProgressaoRegisto[]>([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!funcionarioId) {
      setProgressoes([]);
      return;
    }
    setLoading(true);
    const { data, error } = await supabase
      .from('progressoes')
      .select('*')
      .eq('funcionario_id', funcionarioId)
      .order('data_progressao', { ascending: true });

    if (!error && data) {
      setProgressoes(
        data.map((row) => ({
          id: row.id as string,
          funcionarioId: row.funcionario_id as string,
          dataProgressao: row.data_progressao as string,
          nivelAnterior: row.nivel_anterior as number,
          nivelNovo: row.nivel_novo as number,
          pontosDescontados: Number(row.pontos_descontados),
          observacoes: row.observacoes as string | null,
          aceleradorRemuneratorio: !!row.acelerador_remuneratorio,
          createdAt: row.created_at as string,
        }))
      );
    }
    setLoading(false);
  }, [funcionarioId]);

  useEffect(() => {
    load();
  }, [load]);

  return { progressoes, loading, reload: load };
}